import * as Flags from 'country-flag-icons/react/3x2';

type CountryFlagProps = {
  countryCode: string;
  size?: number;
};

export default function CountryFlag({ countryCode, size = 24 }: CountryFlagProps) {
  const Flag = Flags[countryCode as keyof typeof Flags];

  if (!Flag) {
    return <span></span>; // fallback if invalid code
  }

  return <Flag className="flag" style={{ width: size, height: 'auto' }} />;
}
